import { useActiveSchema } from 'app/branches/hooks/use-active-schema';
import type { ImmutableMap } from 'app/common/utils/immutable-types';
import { getData } from 'app/schema-form/selectors';
import type { WidgetProps } from 'app/schema-form/types';
import { fromJS } from 'immutable';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { TOOL_FORM_NAME } from '../../../constants.js';
import type { ToolEditorFormState } from '../../../types.js';

export type ToolArgumentPickerOwnProps = WidgetProps;

export function useToolArgumentPicker(props: ToolArgumentPickerOwnProps) {
  const toolFormState = useSelector(
    (state) => getData(state, { formName: TOOL_FORM_NAME }) as ImmutableMap<ToolEditorFormState>
  );
  const { activeRuntimeSchema } = useActiveSchema();
  const config = useMemo(() => {
    const currentToolRef = toolFormState.getIn(['execution', 'query', 'ref']);

    if (typeof currentToolRef !== 'string') {
      return props.config;
    }

    const argsSchema = activeRuntimeSchema?.getQuery(currentToolRef)?.argsSchema;

    if (!argsSchema) {
      return props.config;
    }

    const options = Object.keys(argsSchema.properties).map((argName) => ({
      label: argName,
      value: argName
    }));

    return props.config.setIn(['options'], fromJS(options));
  }, [props.config, toolFormState, activeRuntimeSchema]);

  return {
    ...props,
    config
  };
}

export type ToolArgumentPickerProps = ReturnType<typeof useToolArgumentPicker>;
